<template>
  <v-container class="mt-14">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12">
        <v-row align-center column justify-center>
          <vendor-companies-list />
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VendorCompaniesList from '../components/VendorCompaniesList.vue'

export default {
  name: "VendorCompaniesPage",
  components: {
    VendorCompaniesList,
  }
}
</script>
